import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Button, Row, Col } from '_zari/core'

import * as FormGroups from './formGroups'

import * as AsientoContableService from 'services/asientosContables.service'
import { MesesContabilidadConstant } from 'constants/index'

const CorreccionDuplicadosSection = () => {
    const __zariContext = React.useContext(ZariContext)
    const [mesSeleccionado, setMesSeleccionado] = React.useState(MesesContabilidadConstant.APERTURA)


    const clickProcesar = React.useCallback(() => {
        AsientoContableService.corregirDuplicados({ mes: mesSeleccionado })
            .then(({ data }) => {
                if (data) {
                    __zariContext.snack('success', "Los asientos duplicados fueron corregidos")
                }
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }, [mesSeleccionado, __zariContext])

    return (
        <Portlet>
            <Portlet.Header title='Correccion Duplicados' />
            <Portlet.Body>
                <Row>
                    <Col md={4} className='text-left'>
                        <FormGroups.MesContabilidadFormGroup value={mesSeleccionado} onChange={e => setMesSeleccionado(e.target.value)} />

                    </Col>
                </Row>
                <Row>
                    <Col md={4} className='text-right'>
                        <Button onClick={clickProcesar}>Procesar</Button>
                    </Col>
                </Row>
            </Portlet.Body>
        </Portlet>
    )
}

export default React.memo(CorreccionDuplicadosSection)
